import { render, staticRenderFns } from "./BCol.vue?vue&type=template&id=71ff71c6&"
import script from "./BCol.vue?vue&type=script&lang=ts&"
export * from "./BCol.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports